export const graphqlBaseUrl = "https://api.certify.social/graphql/certify-social/admin";
export const paysackBaseUrl = "";
